/**
 * Format a fraction (0...1) into a percent, rounded to the nearest decimal place.
 *
 * @param value - The fraction value to convert (0...1)
 * @param asNumber - If true, returns the numeric value without the '%' symbol. Defaults to false.
 * @returns A formatted percent string (e.g., '42%') or a number (e.g., 42) if asNumber is true
 *
 * @example
 * toRoundedPercent(0.42555) === '42%'
 * toRoundedPercent(0.42555, true) === 42
 */
export default function toRoundedPercent(value: number, asNumber = false): string | number {
  const rounded = Math.round(value * 100)
  return asNumber ? rounded : `${rounded}%`
}
